const API_BASE_URL = 'https://pets.libaroh.de';

const PET_TYPES = {
  DOG: 1,
  CAT: 2,
  ADULT_DOG: 3,
  ADULT_CAT: 4
};

const AGE_THRESHOLDS = {
  DOG_ADULT_MONTHS: 6,
  CAT_ADULT_MONTHS: 12
};

const FOOD_RATIOS = {
  [PET_TYPES.DOG]: 0.03,
  [PET_TYPES.CAT]: 0.08,
  [PET_TYPES.ADULT_DOG]: 0.02,
  [PET_TYPES.ADULT_CAT]: 0.05
};

const WEEKDAYS = [
  { label: 'Montag', value: 'monday' },
  { label: 'Dienstag', value: 'tuesday' },
  { label: 'Mittwoch', value: 'wednesday' },
  { label: 'Donnerstag', value: 'thursday' },
  { label: 'Freitag', value: 'friday' },
  { label: 'Samstag', value: 'saturday' },
  { label: 'Sonntag', value: 'sunday' }
];

const DAYTIMES = [
  { label: 'Morgens', value: 'morgens' },
  { label: 'Mittags', value: 'mittags' },
  { label: 'Abends', value: 'abends' }
];

const SELLING_PLAN_IDS = [
  '689988731215',
  '689988763983',
  '689988796751',
  '689988829519',
  '689988862287',
  '689988895055'
];

const PRODUCTS = [
  {
    regular: 'Blättermagen<br>„Geflügel"',
    weights: { w300: 43140615897309, w600: 43140615930077 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: 'Rindfleisch<br>„Obst & Gemüse"',
    weights: { w300: 43251901399261, w600: 43251901366493 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: 'Blättermagen<br>„Mix"',
    weights: { w300: 43219353632989, w600: 43219353665757 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: 'Pansen<br>„Mix Rind"',
    weights: { w300: 43251840254173, w600: 43251840221405 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: 'Geflügel<br>„Fisch"',
    weights: { w300: 43226436468957, w600: 43226436534493 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: 'Pute<br>„Obst & Gemüse"',
    weights: { w300: 43251867713757, w600: 43251867680989 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: 'Vital<br>„Mix',
    weights: { w300: 43252286521565, w600: 43252286488797 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: "Cat's Geflügel",
    weights: { w300: 43219994902749, w600: 43219994935517 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: "Cat's Rind",
    weights: { w300: 43220021477597, w600: 43220021510365 },
    sellingplans: SELLING_PLAN_IDS
  },
  {
    regular: "Cat's <br>Kaninchen & Lachs",
    weights: { w300: 43219465142493, w600: 43219465175261 },
    sellingplans: SELLING_PLAN_IDS
  }
];

const OIL_PRODUCTS = {
  [PET_TYPES.DOG]: { id: 43251628638429, sellingplans: SELLING_PLAN_IDS },
  [PET_TYPES.CAT]: { id: 43251628605661, sellingplans: SELLING_PLAN_IDS }
};

const FUR_PRODUCTS = {
  [PET_TYPES.DOG]: { id: 43328853573853, sellingplans: SELLING_PLAN_IDS }
};

// ============================================================================
// FEEDING PLANS
// ============================================================================

const PUPPY_FOODPLAN = {
  portions: 3,
  morgens: [
    { regular: 'Blättermagen<br>„Geflügel"', extra: 'oil' },
    { regular: 'Rindfleisch<br>„Obst & Gemüse"', extra: 'oil' },
    { regular: 'Blättermagen<br>„Mix"', extra: 'oil' },
    { regular: 'Pansen<br>„Mix Rind"', extra: 'oil' },
    { regular: 'Geflügel<br>„Fisch"', extra: 'oil' },
    { regular: 'Pute<br>„Obst & Gemüse"', extra: 'oil' },
    { regular: 'Vital<br>„Mix', extra: 'oil' }
  ],
  mittags: [
    { regular: 'Blättermagen<br>„Geflügel"', extra: 'food', food: 'Hähnchenhals' },
    { regular: 'Rindfleisch<br>„Obst & Gemüse"' },
    { regular: 'Blättermagen<br>„Mix"', extra: 'food', food: 'Hähnchenhals' },
    { regular: 'Pansen<br>„Mix Rind"' },
    { regular: 'Geflügel<br>„Fisch"', extra: 'food', food: 'Hähnchenhals' },
    { regular: 'Pute<br>„Obst & Gemüse"' },
    { regular: 'Vital<br>„Mix', extra: 'food', food: 'Hähnchenhals' }
  ],
  abends: [
    { regular: 'Blättermagen<br>„Geflügel"' },
    { regular: 'Rindfleisch<br>„Obst & Gemüse"', extra: 'fur' },
    { regular: 'Blättermagen<br>„Mix"' },
    { regular: 'Pansen<br>„Mix Rind"' },
    { regular: 'Geflügel<br>„Fisch"', extra: 'fur' },
    { regular: 'Pute<br>„Obst & Gemüse"' },
    { regular: 'Vital<br>„Mix' }
  ]
};

const KITTEN_FOODPLAN = {
  portions: 3,
  morgens: [
    { regular: "Cat's Geflügel", extra: 'oil' },
    { regular: "Cat's Rind", extra: 'oil' },
    { regular: "Cat's Geflügel", extra: 'oil' },
    { regular: "Cat's Rind", extra: 'oil' },
    { regular: "Cat's Geflügel", extra: 'oil' },
    { regular: "Cat's Rind", extra: 'oil' },
    { regular: "Cat's Geflügel", extra: 'oil' }
  ],
  mittags: [
    { regular: "Cat's Geflügel", food: 'Hähnchenhals' },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel", food: 'Hähnchemägen' },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel", food: 'Hähnchenherz' },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel", food: 'Sprotten' }
  ],
  abends: [
    { regular: "Cat's Geflügel" },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel" },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel" },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel" }
  ]
};

const ADULT_DOG_FOODPLAN = {
  portions: 2,
  morgens: [
    { regular: 'Blättermagen<br>„Geflügel"', extra: 'oil' },
    { regular: 'Rindfleisch<br>„Obst & Gemüse"', extra: 'oil' },
    { regular: 'Blättermagen<br>„Mix"', extra: 'oil' },
    { regular: 'Pansen<br>„Mix Rind"', extra: 'oil' },
    { regular: 'Geflügel<br>„Fisch"', extra: 'oil' },
    { regular: 'Pute<br>„Obst & Gemüse"', extra: 'oil' },
    { regular: 'Vital<br>„Mix', extra: 'oil' }
  ],
  abends: [
    { regular: 'Blättermagen<br>„Geflügel"' },
    { regular: 'Rindfleisch<br>„Obst & Gemüse"' },
    { regular: 'Blättermagen<br>„Mix"', extra: 'fur' },
    { regular: 'Pansen<br>„Mix Rind"' },
    { regular: 'Geflügel<br>„Fisch"', extra: 'fur' },
    { regular: 'Pute<br>„Obst & Gemüse"' },
    { regular: 'Vital<br>„Mix', extra: '1 gekochtes Ei' }
  ]
};

const ADULT_CAT_FOODPLAN = {
  portions: 2,
  morgens: [
    { regular: "Cat's Geflügel", extra: 'oil' },
    { regular: "Cat's Rind", extra: 'oil' },
    { regular: "Cat's Geflügel", extra: 'oil' },
    { regular: "Cat's Rind", extra: 'oil' },
    { regular: "Cat's Geflügel", extra: 'oil' },
    { regular: "Cat's Rind", extra: 'oil' },
    { regular: "Cat's Geflügel", extra: 'oil' }
  ],
  abends: [
    { regular: "Cat's Geflügel", food: 'Hähnchenhals' },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel", food: 'Hähnchemägen' },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel", food: 'Hähnchenherz' },
    { regular: "Cat's Rind" },
    { regular: "Cat's Geflügel", food: 'Sprotten' }
  ]
};

const FOODPLANS = {
  [PET_TYPES.DOG]: PUPPY_FOODPLAN,
  [PET_TYPES.CAT]: KITTEN_FOODPLAN,
  [PET_TYPES.ADULT_DOG]: ADULT_DOG_FOODPLAN,
  [PET_TYPES.ADULT_CAT]: ADULT_CAT_FOODPLAN
};

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================

/**
 * Calculate age in months from birthday
 */
function calculateAgeInMonths(birthday) {
  const today = new Date();
  const birthDate = new Date(birthday);
  const yearsDiff = today.getFullYear() - birthDate.getFullYear();
  const monthsDiff = today.getMonth() - birthDate.getMonth();
  return yearsDiff * 12 + monthsDiff;
}

/**
 * Determine the effective pet type based on age
 */
function getEffectivePetType(type, birthday) {
  const ageInMonths = calculateAgeInMonths(birthday);
  const petType = parseInt(type);
  
  if (petType === PET_TYPES.DOG && ageInMonths >= AGE_THRESHOLDS.DOG_ADULT_MONTHS) {
    return PET_TYPES.ADULT_DOG;
  }
  if (petType === PET_TYPES.CAT && ageInMonths >= AGE_THRESHOLDS.CAT_ADULT_MONTHS) {
    return PET_TYPES.ADULT_CAT;
  }
  return petType;
}

/**
 * Get food ratio based on pet type and age
 */
function getFoodRatio(type, birthday) {
  const effectiveType = getEffectivePetType(type, birthday);
  return FOOD_RATIOS[effectiveType] || 0.02;
}

/**
 * Validate email format
 */
function isValidEmail(email) {
  const emailRegex = /\S+@\S+\.\S+/;
  if (!emailRegex.test(email)) return false;
  const parts = email.split('.');
  return parts[parts.length - 1].length > 1;
}

/**
 * Create default pet object
 */
function createDefaultPet() {
  return {
    status: 0,
    type: 0,
    name: '',
    race: 0,
    weight: '',
    birthday: '',
    image: null,
    hasCustomImage: false
  };
}

/**
 * Deep clone an object
 */
function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

// ============================================================================
// API SERVICE
// ============================================================================

const PetAPI = {
  async getRaces() {
    try {
      const response = await fetch(`${API_BASE_URL}/races`);
      if (!response.ok) throw new Error('Failed to fetch races');
      return await response.json();
    } catch (error) {
      console.error('Error fetching races:', error);
      return [];
    }
  },

  async getPets(email) {
    try {
      const response = await fetch(`${API_BASE_URL}/getpets/${email || 'noemail'}`);
      if (!response.ok) throw new Error('Failed to fetch pets');
      return await response.json();
    } catch (error) {
      console.error('Error fetching pets:', error);
      return { pets: [], image: null };
    }
  },

  async savePet(petData) {
    const response = await fetch(`${API_BASE_URL}/pet`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(petData)
    });

    let data = null;
    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }

    if (!response.ok) {
      const message = data?.error || data?.message || `HTTP ${response.status}`;
      throw new Error(message);
    }

    return data;
  },

  async deletePet(petId) {
    try {
      const response = await fetch(`${API_BASE_URL}/deletepet/${petId}`);
      if (!response.ok) throw new Error('Failed to delete pet');
      return await response.json();
    } catch (error) {
      console.error('Error deleting pet:', error);
      throw error;
    }
  }
};

// ============================================================================
// CART SERVICE
// ============================================================================

const CartService = {
  async addItems(items) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify({ items })
      });
      
      if (!response.ok) throw new Error('Failed to add items to cart');
      
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      
      return await response.json();
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  },

  calculateQuantities(weight) {
    const w600 = Math.round((weight - 0.01) / 600);
    const w300 = Math.ceil((weight - w600 * 600) / 300);
    return { w600, w300 };
  },

  findProduct(name) {
    return PRODUCTS.find(p => p.regular === name);
  }
};

// ============================================================================
// PDF SERVICE
// ============================================================================

const GUEST_EMAIL_STORAGE_KEY = 'libaroh_guest_email';

const PdfService = {
  generate(pet, foodplan, petIndex, races, getFoodRatioFn, containerEl) {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });

    const config = {
      mx: 16,
      my: 16,
      spread: 297 - 32,
      lineHeight: 4.6,
      rowHeight: 25,
      offset: 24
    };
    
    config.column = config.spread / 7.2;

    doc.setDrawColor('#6c863b');

    // Add pet image
    this._addPetImage(doc, pet, petIndex, config, containerEl);
    
    // Add logo
    this._addLogo(doc, config, containerEl);
    
    // Add pet details
    this._addPetDetails(doc, pet, races, foodplan, getFoodRatioFn, config);
    
    // Add weekday headers
    this._addWeekdayHeaders(doc, config);
    
    // Add foodplan content
    this._addFoodplanContent(doc, pet, foodplan, getFoodRatioFn, config);

    doc.save('Libaroh Futterplan.pdf');
  },

  _addPetImage(doc, pet, petIndex, config, containerEl) {
    const petImage = containerEl
      ? containerEl.querySelector(`[data-pet-image="${petIndex}"]`)
      : document.querySelector(`#image${petIndex}`);
    if (!petImage) return;

    const imageWidth = 40 * (petImage.width / petImage.height);
    const canvas = document.createElement('canvas');
    canvas.width = petImage.width;
    canvas.height = petImage.height;
    
    const ctx = canvas.getContext('2d');
    ctx.drawImage(petImage, 0, 0);
    
    const dataURL = pet.image 
      ? canvas.toDataURL('image/jpeg') 
      : 'https://cdn.shopify.com/s/files/1/0646/3468/3613/files/FoodplanDummy.png?v=1682513273';
    
    doc.addImage(dataURL, 'JPEG', config.mx, config.my, imageWidth, 40);
    
    return imageWidth;
  },

  _addLogo(doc, config, containerEl) {
    const logo = containerEl
      ? containerEl.querySelector('.libaroh-pets__logo')
      : document.querySelector('#libarohpets > img:first-child, .libaroh-pets__logo');
    if (!logo) return;

    const logoWidth = 50;
    const logoHeight = logoWidth * (323 / 1024);
    doc.addImage(logo.src, 'JPEG', 297 - config.mx - logoWidth, 210 - config.my - logoHeight, logoWidth, logoHeight);
  },

  _addPetDetails(doc, pet, races, foodplan, getFoodRatioFn, config) {
    const imageWidth = 40 * 1.5; // Approximate
    const effectiveType = getEffectivePetType(pet.type, pet.birthday);
    const foodRatio = getFoodRatioFn(pet.type, pet.birthday);
    const portion = Math.ceil(pet.weight * 1000 * (foodRatio / foodplan.portions));

    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text(`Ernährungsempfehlung für ${pet.name}`, config.mx + 10 + imageWidth, config.my + 7);
    
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(96, 117, 42);
    doc.text('www.libaroh.de', config.mx, 205 - config.my);
    
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    
    const raceName = races[pet.race - 1]?.race || 'Unbekannt';
    const formattedBirthday = pet.birthday.split('-').reverse().join('.');
    
    doc.text(
      `${raceName} mit ${pet.weight}kg – Geboren am ${formattedBirthday}`, 
      config.mx + 10 + imageWidth, 
      config.my + 14
    );
    doc.text(
      `Eine Mahlzeit besteht aus ${portion}g pro Portion und richtet sich nach dem Körpergewicht von ${pet.name}.`, 
      config.mx + 10 + imageWidth, 
      config.my + 28
    );
    doc.text(
      `Bitte individuell an die Lebensumstände von ${pet.name} anpassen. (Auslauf, Aktivität, Rasse, Stoffwechsel, Jahreszeit)`, 
      config.mx + 10 + imageWidth, 
      config.my + 33
    );
    doc.text(
      'Wir empfehlen, das Gewicht regelmäßig zu kontrollieren.', 
      config.mx + 10 + imageWidth, 
      config.my + 38
    );
  },

  _addWeekdayHeaders(doc, config) {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9.2);
    
    WEEKDAYS.forEach((day, index) => {
      doc.text(day.label, config.mx + config.column * 0.5 + config.column * index, config.offset + config.my + 30);
    });
  },

  _addFoodplanContent(doc, pet, foodplan, getFoodRatioFn, config) {
    const effectiveType = getEffectivePetType(pet.type, pet.birthday);
    const plan = FOODPLANS[effectiveType];
    if (!plan) return;

    const foodRatio = getFoodRatioFn(pet.type, pet.birthday);
    const portion = Math.ceil(pet.weight * 1000 * (foodRatio / plan.portions));
    let row = 0;

    DAYTIMES.forEach(daytime => {
      const meals = plan[daytime.value];
      if (!meals) return;

      doc.setFont('helvetica', 'bold');
      doc.text(daytime.label, config.mx, config.offset + config.my + 40 + config.rowHeight * row);

      meals.forEach((day, dayIndex) => {
        const x = config.mx + config.column * 0.5 + config.column * dayIndex;
        const y = config.offset + config.my + 40 + config.rowHeight * row;

        doc.setFont('helvetica', 'bold');
        doc.text(day.regular.split('<br>'), x, y);
        
        doc.setFont('helvetica', 'normal');
        doc.text(`${portion} g`, x, y + config.lineHeight + 3);

        if (day.extra === 'oil') {
          doc.text(`${Math.ceil(pet.weight / 10)} TL Öl`, x, y + config.lineHeight * 2 + 4);
        } else if (day.extra === 'fur') {
          doc.text('1 x Fell', x, y + config.lineHeight * 2 + 4);
        } else if (day.extra === 'food') {
          doc.text(day.food, x, y + config.lineHeight * 2 + 4);
        }

        // Draw vertical line
        doc.line(
          x - 2, 
          config.offset + config.my + 34 + config.rowHeight * row,
          x - 2, 
          config.offset + config.my + 32 + config.rowHeight * (row + 1)
        );
      });

      // Draw horizontal line
      doc.line(
        config.mx, 
        config.offset + config.my + 33 + config.rowHeight * row, 
        config.mx + config.spread, 
        config.offset + config.my + 33 + config.rowHeight * row
      );
      
      row++;
    });

    // Final horizontal line
    doc.line(
      config.mx, 
      config.offset + config.my + 33 + config.rowHeight * row, 
      config.mx + config.spread, 
      config.offset + config.my + 33 + config.rowHeight * row
    );
    
    // Top line
    doc.line(config.mx, config.offset + config.my + 33, config.mx + config.spread, config.offset + config.my + 33);
  }
};

// ============================================================================
// VUE COMPONENT: Foodplan Header
// ============================================================================

if (!window.__libarohFoodplanHeaderRegistered) {
  Vue.component('foodplan-header', {
  props: {
    petName: String,
    sellingPlan: Number,
    addingToCart: Boolean
  },
  template: `
    <div class="title">
      <h2>Dein Futterplan<br>für {{ petName }}</h2>
      <div>
        <select :value="sellingPlan" @input="$emit('update:sellingPlan', parseInt($event.target.value))">
          <option value="0">Einmalig</option>
          <option value="1">Jede Woche</option>
          <option value="2">Alle 2 Wochen</option>
          <option value="3">Alle 3 Wochen</option>
          <option value="4">Alle 4 Wochen</option>
          <option value="5">Alle 5 Wochen</option>
          <option value="5">Alle 6 Wochen</option>
        </select>
        <button class="btn btn--no-animate" :class="{ disabled: addingToCart }" :disabled="addingToCart" @click="$emit('add-to-cart')">
          <span v-if="!addingToCart">In den Warenkorb</span>
          <span v-else>Ein Moment bitte …</span>
        </button>
        <button class="btn btn--no-animate" @click="$emit('download-pdf')">PDF</button>
        <button class="btn btn--no-animate" @click="$emit('close')">Schließen</button>
      </div>
    </div>
  `
  });
  window.__libarohFoodplanHeaderRegistered = true;
}

// Version: 2026-05-19-guestemail-fix (cache-bust marker)

// ============================================================================
// VUE APP
// ============================================================================

window.LibarohPetManagement = window.LibarohPetManagement || {
  instances: {},

  init(containerEl, config) {
    if (!containerEl || typeof Vue === 'undefined') return null;

    const instanceKey = config.sectionId || containerEl.id;
    if (this.instances[instanceKey]) {
      this.instances[instanceKey].$destroy();
      delete this.instances[instanceKey];
    }

    const vm = new Vue({
    el: containerEl,
    delimiters: ['${', '}'],
    
    data: {
      sectionId: config.sectionId || '',
      swiper: null,
      blockUI: false,
      addingToCart: false,
      activeFoodplanIndex: null,
      foodplanAttempted: false,
      saveAttempted: false,
      
      customerEmail: config.customerEmail || '',
      email: config.customerEmail || '',
      customerId: config.customerId || '',
      firstName: config.firstName || '',
      lastName: config.lastName || '',
      guestEmail: '',
      termsAccepted: false,
      
      races: [],
      pets: [],
      petsShadow: [],
      activeSlideIndex: 0,
      defaultPetImage: null,
      
      sellingPlan: 0,
      weekdays: WEEKDAYS,
      daytimes: DAYTIMES,

      overlayMode: !!config.overlayMode,
      overlayOpen: false,
      launcherLabel: config.launcherLabel || 'Futterplan erstellen',
      escHandler: null
    },

    computed: {
      isLoggedIn() {
        return this.customerEmail !== '';
      },

      isGuestEmailValid() {
        return isValidEmail(this.guestEmail) && this.termsAccepted;
      },

      activeFoodplanPet() {
        if (this.activeFoodplanIndex === null) return null;
        return this.pets[this.activeFoodplanIndex] || null;
      },

      activePet() {
        return this.pets[this.activeSlideIndex] || null;
      },

      activePetFormState() {
        return this.petFormState(this.activeSlideIndex);
      }
    },

    methods: {
      // ========== INITIALIZATION ==========
      
      bindSwiperNav(root, swiperInstance) {
        const nextEl = root.querySelector('.button.next');
        const prevEl = root.querySelector('.button.previous');

        if (this._swiperNavNext) {
          this._swiperNavNext.removeEventListener('click', this._swiperNavNextHandler);
        }
        if (this._swiperNavPrev) {
          this._swiperNavPrev.removeEventListener('click', this._swiperNavPrevHandler);
        }

        if (nextEl) {
          this._swiperNavNext = nextEl;
          this._swiperNavNextHandler = (e) => {
            e.preventDefault();
            swiperInstance.slideNext();
          };
          nextEl.addEventListener('click', this._swiperNavNextHandler);
        }

        if (prevEl) {
          this._swiperNavPrev = prevEl;
          this._swiperNavPrevHandler = (e) => {
            e.preventDefault();
            swiperInstance.slidePrev();
          };
          prevEl.addEventListener('click', this._swiperNavPrevHandler);
        }
      },

      initSwiper() {
        const root = this.$el;
        const container = root.querySelector('.swiper-container');
        const slides = container?.querySelectorAll('.swiper-slide');
        if (!container || !slides?.length) return;

        if (this.swiper) {
          try {
            this.swiper.destroy(true, true);
          } catch (e) { /* ignore */ }
          this.swiper = null;
        }

        const swiperInstance = new Swiper(container, {
          init: false,
          slidesPerView: 'auto',
          spaceBetween: 30,
          centeredSlides: true,
          simulateTouch: false,
          breakpoints: {
            768: { spaceBetween: 20 },
            640: { spaceBetween: 10 }
          }
        });

        this.swiper = swiperInstance;
        this.bindSwiperNav(root, swiperInstance);

        const syncActiveIndex = () => {
          const index = swiperInstance?.activeIndex;
          if (typeof index === 'number') {
            this.activeSlideIndex = index;
          }
        };

        const refreshSwiperLayout = () => {
          swiperInstance.update();
        };

        swiperInstance.on('slideChange', () => {
          syncActiveIndex();
          refreshSwiperLayout();
        });
        swiperInstance.on('slideChangeTransitionEnd', refreshSwiperLayout);
        swiperInstance.init();
        syncActiveIndex();
        refreshSwiperLayout();

        const targetIndex = Math.min(
          this.activeSlideIndex || 0,
          Math.max(0, slides.length - 1)
        );
        swiperInstance.slideTo(targetIndex, 0);
        syncActiveIndex();
        refreshSwiperLayout();
      },

      async loadRaces() {
        this.races = await PetAPI.getRaces();
      },

      getLoadEmail() {
        if (this.customerEmail) return this.customerEmail;
        if (this.email) return this.email;
        if (this.guestEmail) return this.guestEmail;
        try {
          return localStorage.getItem(GUEST_EMAIL_STORAGE_KEY) || '';
        } catch (e) {
          return '';
        }
      },

      mapPetFromApi(pet) {
        return {
          ...pet,
          type: parseInt(pet.type, 10) || 0,
          race: parseInt(pet.race ?? pet.race_id, 10) || 0,
          weight: pet.weight ?? '',
          birthday: pet.birthday || '',
          hasCustomImage: !!pet.image
        };
      },

      hasPetSavedId(pet) {
        if (!pet) return false;
        const id = pet.id;
        return id !== undefined && id !== null && id !== '' && Number(id) > 0;
      },

      async loadPets() {
        const data = await PetAPI.getPets(this.getLoadEmail());
        
        if (data.pets?.length && !this.pets.length) {
          this.pets = deepClone(data.pets).map((pet) => this.mapPetFromApi(pet));
          this.petsShadow = deepClone(this.pets);
        }
        
        this.defaultPetImage = data.image;
        this.swiper?.update();
      },

      // ========== PET MANAGEMENT ==========
      
      addPet() {
        const newPet = createDefaultPet();
        newPet.image = this.defaultPetImage;
        
        this.pets.push(newPet);
        this.petsShadow.push(deepClone(newPet));
        
        this.swiper?.update();
        
        const newIndex = this.pets.length - 1;
        this.activeSlideIndex = newIndex;
        setTimeout(() => {
          if (!this.swiper) return;
          this.swiper.slideTo(newIndex, 0);
          this.activeSlideIndex = this.swiper.activeIndex;
        }, 100);
      },

      petFormState(index) {
        const pet = this.pets[index];
        if (!pet) {
          return { canShowFoodplan: false, canSave: false };
        }

        const name = String(pet.name || '').trim();
        const type = parseInt(pet.type, 10) || 0;
        const race = parseInt(pet.race, 10) || 0;
        const weight = pet.weight;
        const birthday = pet.birthday || '';
        const guestOk = this.isLoggedIn ||
          (isValidEmail(this.guestEmail) && this.termsAccepted);

        const canShowFoodplan = !!(name && type > 0 && this.isValidWeight(weight) &&
          birthday && birthday !== '2023-01-01');
        const canSave = canShowFoodplan && race > 0 && guestOk &&
          !(this.hasPetSavedId(pet) && !this.hasPetChanged(index));

        return { canShowFoodplan, canSave };
      },

      preparePetForApi(index) {
        const pet = this.pets[index];
        const email = this.isLoggedIn ? this.email : this.guestEmail;

        const payload = deepClone(pet);
        delete payload.hasCustomImage;

        payload.email = email;
        payload.firstname = this.firstName;
        payload.lastname = this.lastName;
        payload.customer_id = this.customerId ? parseInt(this.customerId, 10) || 0 : 0;
        payload.status = 1;
        payload.type = parseInt(payload.type, 10) || 0;
        payload.race = parseInt(payload.race, 10) || 0;

        payload.weight = String(payload.weight ?? '').replace(',', '.').trim();

        if (!pet.hasCustomImage) {
          payload.image = this.defaultPetImage || null;
        }

        return payload;
      },

      async storePet(index) {
        this.saveAttempted = true;
        this.setActiveSlide(index);

        const pet = this.pets[index];
        if (!pet) return;

        const formState = this.petFormState(index);
        if (!formState.canSave) {
          if (!this.isLoggedIn && !this.isGuestEmailValid) {
            alert('Bitte E-Mail-Adresse eingeben und der Datenschutzerklärung zustimmen.');
          }
          return;
        }

        if (!this.isLoggedIn) {
          this.email = this.guestEmail;
          try {
            localStorage.setItem(GUEST_EMAIL_STORAGE_KEY, this.guestEmail);
          } catch (e) { /* ignore */ }
        }

        this.blockUI = true;

        try {
          const petData = this.preparePetForApi(index);
          const result = await PetAPI.savePet(petData);
          const newId = result?.id ?? result?.pet?.id ?? result?.data?.id;

          if (newId && !this.hasPetSavedId(this.pets[index])) {
            Vue.set(this.pets[index], 'id', newId);
          }

          this.pets[index].email = petData.email;
          this.pets[index].status = 1;
          Vue.set(this.petsShadow, index, deepClone(this.pets[index]));
        } catch (error) {
          console.error('Error saving pet:', error);
          alert('Fehler beim Speichern: ' + (error.message || 'Bitte versuche es erneut.'));
        } finally {
          setTimeout(() => {
            this.blockUI = false;
          }, 500);
        }
      },

      async deletePet(index) {
        if (!confirm('Wirklich entfernen?')) return;
        
        try {
          await PetAPI.deletePet(this.pets[index].id);
          this.pets.splice(index, 1);
          this.petsShadow.splice(index, 1);
          if (this.activeSlideIndex >= this.pets.length) {
            this.activeSlideIndex = Math.max(0, this.pets.length - 1);
          }
          this.swiper?.update();
          this.swiper?.slideTo(this.activeSlideIndex, 0);
        } catch (error) {
          alert('Fehler beim Löschen. Bitte versuche es erneut.');
        }
      },

      setActiveSlide(index) {
        this.activeSlideIndex = index;
        if (this.swiper && this.swiper.activeIndex !== index) {
          this.swiper.slideTo(index, 0);
        }
      },

      petSlideSelector(index) {
        return `#pet-${this.sectionId}-${index}`;
      },

      loadImage(index) {
        const fileInput = this.$el.querySelector(`${this.petSlideSelector(index)} input[type="file"]`);
        const file = fileInput?.files[0];
        
        if (!file) return;
        
        this.blockUI = true;
        const reader = new FileReader();
        
        reader.addEventListener('load', (event) => {
          this.pets[index].image = event.target.result;
          this.pets[index].hasCustomImage = true;
          this.blockUI = false;
        });
        
        reader.addEventListener('error', () => {
          alert('Fehler beim Laden des Bildes.');
          this.blockUI = false;
        });
        
        reader.readAsDataURL(file);
      },

      // ========== VALIDATION ==========

      petTypeValue(pet) {
        return parseInt(pet.type, 10) || 0;
      },

      petRaceValue(pet) {
        return parseInt(pet.race, 10) || 0;
      },

      isPetValidForFoodplan(pet) {
        return !!(pet.name && String(pet.name).trim()) &&
               this.petTypeValue(pet) > 0 &&
               this.isValidWeight(pet.weight) &&
               !this.isDefaultBirthday(pet.birthday);
      },

      isPetValidForSave(pet) {
        return this.isPetValidForFoodplan(pet) && this.petRaceValue(pet) > 0;
      },

      showFoodplanFieldError(pet, field) {
        if (field === 'race') {
          return this.saveAttempted && !this.petRaceValue(pet);
        }
        return this.foodplanAttempted && !this.isPetValidForFoodplan(pet);
      },

      isValidWeight(weight) {
        if (weight === null || weight === undefined || weight === '') return false;
        const normalized = String(weight).replace(',', '.').trim();
        const numWeight = parseFloat(normalized);
        return !isNaN(numWeight) && numWeight > 0;
      },

      isDefaultBirthday(birthday) {
        return !birthday || birthday === '2023-01-01';
      },

      setFoodplanOpen(isOpen) {
        this.$el.classList.toggle('foodplan-open', isOpen);
        if (this.overlayMode) {
          document.documentElement.classList.toggle('libaroh-foodplan-open', isOpen);
        }
      },

      normalizePetSnapshot(pet) {
        if (!pet) return {};
        return {
          name: String(pet.name || '').trim(),
          type: parseInt(pet.type, 10) || 0,
          race: parseInt(pet.race, 10) || 0,
          weight: String(pet.weight ?? '').replace(',', '.').trim(),
          birthday: pet.birthday || '',
          hasCustomImage: !!pet.hasCustomImage
        };
      },

      hasPetChanged(index) {
        if (!this.petsShadow[index]) return true;
        return JSON.stringify(this.normalizePetSnapshot(this.pets[index])) !==
          JSON.stringify(this.normalizePetSnapshot(this.petsShadow[index]));
      },

      canSavePet(index) {
        const pet = this.pets[index];
        if (!pet || this.blockUI) return false;
        if (!this.isPetValidForSave(pet)) return false;
        if (!this.isLoggedIn && !this.isGuestEmailValid) return false;
        if (this.hasPetSavedId(pet) && !this.hasPetChanged(index)) return false;
        return true;
      },

      savePetButtonLabel(pet) {
        const name = (pet.name && String(pet.name).trim()) || 'Haustier';
        return this.hasPetSavedId(pet) ? `${name} speichern` : `${name} hinzufügen`;
      },

      canAddAnotherPet() {
        if (this.blockUI || !this.pets.some((p) => this.hasPetSavedId(p))) return false;
        return !this.pets.some((p) => !this.hasPetSavedId(p));
      },

      // ========== FILTERING ==========
      
      filteredRaces(petType) {
        return this.races.filter(race => race.type == petType);
      },

      // ========== OVERLAY ==========

      openOverlay() {
        this.overlayOpen = true;
        if (!document.documentElement.classList.contains('modal-open')) {
          document.documentElement.classList.add('modal-open');
        }

        this.escHandler = (e) => {
          if (e.key !== 'Escape') return;
          if (this.activeFoodplanIndex !== null) {
            this.closeFoodplan();
            return;
          }
          this.closeOverlay();
        };
        document.addEventListener('keydown', this.escHandler);

        const setup = () => {
          if (!this.pets.length) {
            this.addPet();
          }
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              this.initSwiper();
            });
          });
        };

        if (!this._petsLoadedForOverlay) {
          this.loadPets().then(() => {
            this._petsLoadedForOverlay = true;
            setup();
          });
        } else {
          setup();
        }
      },

      closeOverlay() {
        this.closeFoodplan();

        this.overlayOpen = false;
        document.documentElement.classList.remove('modal-open', 'libaroh-foodplan-open');

        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        if (this.escHandler) {
          document.removeEventListener('keydown', this.escHandler);
          this.escHandler = null;
        }
      },

      ensureSwiperReady() {
        if (!this.pets.length) {
          this.addPet();
        }
        this.$nextTick(() => {
          if (!this.swiper) {
            this.initSwiper();
          } else {
            this.swiper.update();
          }
        });
      },

      // ========== FOODPLAN ==========
      
      showFoodplan(index) {
        const pet = this.pets[index];
        if (!this.isPetValidForFoodplan(pet)) {
          this.foodplanAttempted = true;
          return;
        }
        this.activeFoodplanIndex = index;
        this.setFoodplanOpen(true);
        if (!document.documentElement.classList.contains('modal-open')) {
          document.documentElement.classList.add('modal-open');
        }
      },

      closeFoodplan() {
        this.activeFoodplanIndex = null;
        this.setFoodplanOpen(false);
        if (!this.overlayOpen || !this.overlayMode) {
          document.documentElement.classList.remove('modal-open');
        }
      },

      getFoodplanForPet(pet) {
        const effectiveType = getEffectivePetType(pet.type, pet.birthday);
        return FOODPLANS[effectiveType];
      },

      calculatePortion(pet) {
        const foodplan = this.getFoodplanForPet(pet);
        if (!foodplan) return 0;
        
        const ratio = getFoodRatio(pet.type, pet.birthday);
        return Math.ceil(pet.weight * 1000 * (ratio / foodplan.portions));
      },

      calculateOil(pet) {
        return Math.ceil(pet.weight / 10);
      },

      // ========== CART ==========
      
      async addToCart(pet) {
        this.addingToCart = true;
        
        try {
          const effectiveType = getEffectivePetType(pet.type, pet.birthday);
          const foodplan = FOODPLANS[effectiveType];
          if (!foodplan) throw new Error('No foodplan found');

          const sellingPlanValue = this.sellingPlan || 1;
          const ratio = getFoodRatio(pet.type, pet.birthday);
          const weightPerMeal = Math.round(1000 * pet.weight * (ratio / foodplan.portions) * sellingPlanValue);

          const productWeights = {};
          const cartItems = [];

          // Sum up all products from the foodplan
          DAYTIMES.forEach(daytime => {
            const meals = foodplan[daytime.value];
            if (!meals) return;

            meals.forEach(meal => {
              const product = CartService.findProduct(meal.regular);
              if (!product) return;

              const key = product.weights.w300;
              if (!productWeights[key]) {
                productWeights[key] = {
                  regular: product.regular,
                  weight: weightPerMeal,
                  sellingPlan: this.sellingPlan ? product.sellingplans[this.sellingPlan - 1] : null
                };
              } else {
                productWeights[key].weight += weightPerMeal;
              }

              if (meal.extra === 'fur' && FUR_PRODUCTS[pet.type]) {
                cartItems.push({
                  id: FUR_PRODUCTS[pet.type].id,
                  quantity: 1
                });
              }
            });
          });

          // Add oil
          if (OIL_PRODUCTS[pet.type]) {
            cartItems.push({
              id: OIL_PRODUCTS[pet.type].id,
              quantity: 1
            });
          }

          // Add products with correct quantities
          Object.values(productWeights).forEach(item => {
            const product = CartService.findProduct(item.regular);
            if (!product) return;

            const quantities = CartService.calculateQuantities(item.weight);

            if (quantities.w300 > 0) {
              cartItems.push({
                id: product.weights.w300,
                quantity: quantities.w300,
                selling_plan: item.sellingPlan
              });
            }

            if (quantities.w600 > 0) {
              cartItems.push({
                id: product.weights.w600,
                quantity: quantities.w600,
                selling_plan: item.sellingPlan
              });
            }
          });

          await CartService.addItems(cartItems);
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Fehler beim Hinzufügen zum Warenkorb.');
        } finally {
          this.addingToCart = false;
        }
      },

      // ========== PDF ==========
      
      downloadPdf(pet, index) {
        const foodplan = this.getFoodplanForPet(pet);
        if (!foodplan) return;
        
        PdfService.generate(pet, foodplan, index, this.races, getFoodRatio, this.$el);
      }
    },

    mounted() {
      if (!this.isLoggedIn) {
        try {
          const stored = localStorage.getItem(GUEST_EMAIL_STORAGE_KEY);
          if (stored && isValidEmail(stored)) {
            this.guestEmail = stored;
            this.email = stored;
          }
        } catch (e) { /* ignore */ }
      }

      this.loadRaces();

      if (this.overlayMode) {
        return;
      }

      this.loadPets().then(() => {
        this.ensureSwiperReady();
      });
    },

    beforeDestroy() {
      document.documentElement.classList.remove('modal-open', 'libaroh-foodplan-open');
      if (this.escHandler) {
        document.removeEventListener('keydown', this.escHandler);
      }
    }
  });

    this.instances[instanceKey] = vm;
    return vm;
  }
};

function initLibarohPetSections() {
  document.querySelectorAll('[data-libaroh-pet-management]').forEach((container) => {
    if (container.dataset.libarohPetInitialized === 'true') return;

    let config = {};
    try {
      config = JSON.parse(container.dataset.libarohPetConfig || '{}');
    } catch (e) {
      config = {};
    }

    window.LibarohPetManagement.init(container, config);
    container.dataset.libarohPetInitialized = 'true';
  });
}

function bootLibarohPetSections(event) {
  if (event?.type === 'shopify:section:load' && event.target) {
    event.target.querySelectorAll('[data-libaroh-pet-management]').forEach((container) => {
      const key = container.id;
      if (window.LibarohPetManagement?.instances[key]) {
        window.LibarohPetManagement.instances[key].$destroy();
        delete window.LibarohPetManagement.instances[key];
      }
      container.dataset.libarohPetInitialized = 'false';
    });
  }

  initLibarohPetSections();
}

document.addEventListener('shopify:section:load', bootLibarohPetSections);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootLibarohPetSections);
} else {
  bootLibarohPetSections();
}
